import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudDetalle } from "@/lib/types";

/**
 * Sube el PDF de una factura extranjera (subtipo INVOICE) · el backend lo extrae por
 * OCR según la plantilla del cliente, deriva la organización del RFC receptor y guarda
 * los datos en la solicitud. Devuelve el detalle actualizado (con `invoice`).
 */
export const cargaInvoiceApi = {
  cargar: (solicitudId: string, pdf: File) => {
    const form = new FormData();
    form.append("pdf", pdf);
    return axiosClient
      .post<SolicitudDetalle>(`/api/solicitudes/${solicitudId}/invoice`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};
